// extracted by mini-css-extract-plugin
module.exports = {"Brand":"detail_Brand__NKJjw","Image":"detail_Image__kuXFs","Items":"detail_Items__rCBmr"};